import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { Helmet } from "react-helmet";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { CustomInput, Loading } from "@/components";
import { PricingApi } from "@/api";
import { useNavigate, useParams } from "react-router-dom";
import { selectLanguage } from "@/redux-config/entities/language";

export const PricingEdit: React.FC<{}> = () => {

  const { id } = useParams();

  const user = useAppSelector(selectUser);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = useAppSelector(selectLanguage);

  const crumbs = [
    { name: t("Dashboard"), href: "/" },
    { name: t("Pricing"), href: "#" },
    { name: t("New"), href: "#" }
  ];


  const [size, setSize] = useState<string>("");
  const [price, setPrice] = useState<string>("");
  const [bookbindingPrice, setBookbindingPrice] = useState<string>("");
  const [isMultiColor, setIsMultiColor] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [fetchLoading, setfetchLoading] = useState<boolean>(false);

  useEffect(() => {
    setfetchLoading(true);
    PricingApi.GetPricingById(user, id + "").then((data) => {
      setSize(data.data.size ? data.data.size : "");
      setPrice(data.data.price ? data.data.price + "" : "");
      setBookbindingPrice(data.data.bookbinding_price ? data.data.bookbinding_price + "" : "");
      setIsMultiColor(data.data.is_multi_color ? data.data.is_multi_color : false);

      setfetchLoading(false);
    }).catch((err) => {
      setfetchLoading(false);
    });
  }, []);

  const handleCreate = () => {
    setLoading(true);
    PricingApi.EditPricing(user, id + "", size, price, bookbindingPrice, isMultiColor).then((data) => {
      navigate(`/pricing`);
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
    });
  };


  return (
    <>
      <Helmet>
        <title>MahdiBookShop | Pricing List</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      {fetchLoading ? <Loading /> :
        <div className="d-flex flex-column">
          <CustomBreadCrumb breadCrumbList={crumbs} />
          <div className={"d-flex flex-row flex-wrap"}>
            <div className={"col-12 col-md-6 col-lg-4 p-2"}>
              <div
                className={
                  "d-flex flex-column bg-custom-white p-3 rounded-3  gap-2 h-100"
                }
              >
                <h5>{t("BasicInfo")}</h5>
                <label className={"d-flex flex-column"}>
                  <small>{t("Size")}</small>
                  <CustomInput
                    name={"Size"}
                    type={"text_number"}
                    className={`custom-input ${
                      size.length === 0
                        ? "border-reg"
                        : size.length >= 2
                          ? "border-success"
                          : "border-error"
                    }`}
                    value={size}
                    onChange={setSize}
                    lng={lang}
                  />
                </label>
                <label className={"d-flex flex-column"}>
                  <small>{t("PerPrice")}</small>
                  <CustomInput
                    name={"LastName"}
                    type={"price"}
                    className={`custom-input ${
                      price.length === 0
                        ? "border-reg"
                        : price.length >= 2
                          ? "border-success"
                          : "border-error"
                    }`}
                    value={price}
                    onChange={setPrice}
                    lng={lang}
                  />
                </label>
                <label className={"d-flex flex-column"}>
                  <small>{t("BookingPrice")}</small>
                  <CustomInput
                    name={"phone"}
                    type={"price"}
                    className={`custom-input ${
                      bookbindingPrice.length === 0
                        ? "border-reg"
                        : bookbindingPrice.length >= 2
                          ? "border-success"
                          : "border-error"
                    }`}
                    value={bookbindingPrice}
                    onChange={setBookbindingPrice}
                    lng={lang}
                  />
                </label>

                <label className={"d-flex flex-column"}>
                  <small>{t("BookingPrice")}</small>
                  <select
                    className={"custom-input border-reg"}
                    onChange={(e) => {
                      if (e.target.value === "false") {
                        setIsMultiColor(false);
                      } else {
                        setIsMultiColor(true);
                      }
                    }}
                  >
                    <option value={"false"}>{t("black-white")}</option>
                    <option value={"true"}>{t("multi-color")}</option>
                  </select>
                </label>

                <div>
                  <button
                    className={"btn prm-btn rounded-5 px-4 mt-3"}
                    disabled={
                      !(
                        size.length >= 2 &&
                        price.length >= 2 &&
                        bookbindingPrice.length >= 2
                      ) || loading
                    }
                    onClick={() => {
                      handleCreate();
                    }}
                  >
                    {t("submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};
